import { render, staticRenderFns } from "./ModelPerformanceTable.vue?vue&type=template&id=352d61a8&scoped=true&"
import script from "./ModelPerformanceTable.vue?vue&type=script&lang=js&"
export * from "./ModelPerformanceTable.vue?vue&type=script&lang=js&"
import style0 from "./ModelPerformanceTable.vue?vue&type=style&index=0&id=352d61a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d61a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VFlex,VSkeletonLoader,VTextField})
